import type { SVGProps } from 'react';

const SvgDmOffLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M6.23257 3L17.7401 13.7893M6.23257 3V13.7893M6.23257 3H17.7401L17.7401 13.7893M17.7401 13.7893L10.4005 20.6707C9.93221 21.1098 9.17289 21.1098 8.70456 20.6707L4.83873 16.6656C4.37041 16.2265 4.39596 15.5259 4.86428 15.0868L11.9774 8.38563M17.7401 13.7893L11.9774 8.38563M17.7401 13.7893L19.1488 15.0939C19.6171 15.533 19.6171 16.2449 19.1488 16.684L15.2378 20.6589C14.7695 21.098 14.0101 21.098 13.5418 20.6589L11.9774 19.1921L17.7401 13.7893ZM11.9774 8.38563L17.5401 3.17014'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export default SvgDmOffLt;
